// Utilities
import { set } from '../utils';

const DEFAULT_SNACKBAR = Object.freeze({
  color: 'secondary',
  href: false,
  msg: '',
  text: 'Close',
  to: false,
  timeout: 6000,
  top: false,
  right: false,
  bottom: true,
  left: false,
  btnText: false,
  icon: '',
  action: function() {}
});

export const state = {
  snackbar: {
    ...DEFAULT_SNACKBAR
  },
  value: false
};

export const mutations = {
  setSnackbar: (state: any, payload: any) => {
    state.snackbar = Object.assign({}, DEFAULT_SNACKBAR, payload);
  },
  setValue: set('value')
};

export const actions = {
  createSnack: ({ commit }: any, payload: any) => {
    commit('setSnackbar', payload);
  }
};

export const getters = {};
